import { cloneDeep, isArray, unionBy } from 'lodash';

const retrievedAll = (state, action, shouldMerge, key = 'id') => {
  // changed to cloneDeep, because we currently have data models with methods
  // and { ...state } cloning use shallow cloning, and missed methods
  const newState = cloneDeep(state);
  const { entities } = action;
  newState.busy = false;
  if (shouldMerge)
    newState.entities = unionBy(entities, newState.entities, key);
  else newState.entities = entities;
  return newState;
};

const retrievedAllPagination = (state, action) => {
  // changed to cloneDeep, because we currently have data models with methods
  // and { ...state } cloning use shallow cloning, and missed methods
  const newState = cloneDeep(state);
  const { entities, pagination } = action;
  newState.busy = false;
  newState.entities = entities;
  newState.pagination = pagination;
  return newState;
};

const update = (state, action, key = 'id') => {
  const newState = cloneDeep(state);
  const entityIndex = newState.entities.findIndex(
    e => e[key] === action.entity?.[key],
  );
  if (entityIndex === -1) {
    newState.entities.push(action.entity);
  } else {
    newState.entities[entityIndex] = action.entity;
  }

  newState.busy = false;
  return newState;
};

const retrieved = (state, action, key) => {
  return update(state, action, key);
};

const localBatchUpdate = (state, action) => {
  const newState = cloneDeep(state);
  const updatedEntities = {};
  action.entities.forEach(e => {
    updatedEntities[e.id] = e;
  });

  newState.entities = newState.entities.map(e =>
    updatedEntities[e.id] ? { ...e, ...updatedEntities[e.id] } : e,
  );

  return newState;
};

const batchUpdate = (state, action) => {
  const entitiesMap = {};
  action.entities.forEach(e => {
    entitiesMap[e.id] = e;
  });

  const updateCollection = collection => {
    if (!action.appendNew) {
      return collection.map(e => entitiesMap[e.id] || e);
    }
    const updatedIds = new Set(action.entities.map(e => e.id));
    const updatedCollection = collection.map(e => {
      updatedIds.delete(e.id);
      return entitiesMap[e.id] || e;
    });

    return [
      ...updatedCollection,
      ...[...updatedIds].map(eid => entitiesMap[eid]),
    ];
  };

  return {
    ...state,
    entities: updateCollection(state.entities),
    dropdown: updateCollection(state.dropdown),
    busy: false,
  };
};

const deleteLocalFirst = (state, action) => {
  const newState = cloneDeep(state);
  const { entity } = action;
  if (isArray(entity)) {
    newState.entities = newState.entities.filter(
      e => e.id !== entity.includes(e.id),
    );
  } else {
    newState.entities = newState.entities.filter(
      e => e.id !== action.entity.id,
    );
  }
  newState.busy = false;

  return newState;
};

const addEntity = (state, action) => {
  const newState = cloneDeep(state);
  newState.entities.push(action.entity);
  newState.busy = false;
  return newState;
};

const setBusy = (state, args = {}) => ({
  ...state,
  ...args,
  busy: true,
});

const setUnBusy = state => ({
  ...state,
  busy: false,
});

export {
  retrieved,
  retrievedAll,
  update,
  localBatchUpdate,
  batchUpdate,
  deleteLocalFirst,
  setBusy,
  setUnBusy,
  addEntity,
  retrievedAllPagination,
};
